"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../api");
var _RemoveCouponFromPackageButton = _interopRequireDefault(require("./RemoveCouponFromPackageButton.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PackageDetail',
  components: {
    RemoveCouponFromPackageButton: _RemoveCouponFromPackageButton.default
  },
  props: {
    packageId: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      coupons: [],
      searchKeyword: '',
      total: 0,
      pageData: {
        page: 1,
        limit: 10
      }
    };
  },
  computed: {
    filteredCoupons: function filteredCoupons() {
      if (!this.searchKeyword) {
        return this.coupons;
      }
      var keyword = this.searchKeyword.toLowerCase();
      return this.coupons.filter(function (coupon) {
        return coupon && coupon.name && coupon.name.toLowerCase().includes(keyword);
      });
    }
  },
  created: function created() {
    this.fetchCoupons();
    this.$bus.$on('refreshPackageDetail', this.fetchCoupons);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refreshPackageDetail', this.fetchCoupons);
  },
  methods: {
    fetchCoupons: function fetchCoupons() {
      var _this = this;
      if (!this.packageId) return;
      this.loading = true;
      var params = {
        page: this.pageData.page,
        limit: this.pageData.limit
      };
      (0, _api.couponPackageRelationsApi)(this.packageId, params).then(function (res) {
        if (res) {
          _this.coupons = (res.list || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              issueCount: item.quantity || 1
            });
          });
          _this.total = res.total;
          _this.pageData.page = res.page;
          _this.pageData.limit = res.limit;
        } else {
          _this.coupons = [];
          _this.total = 0;
        }
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    searchCoupons: function searchCoupons() {
      // 当前是本地搜索，无需额外处理
    },
    addCoupon: function addCoupon() {
      this.$emit('addCoupon', this.packageId);
    },
    removeCoupon: function removeCoupon(coupon) {
      var _this2 = this;
      this.loading = true;
      var couponId = Number(coupon.id);
      var packageId = Number(this.packageId);
      console.log('Removing coupon', {
        couponId: couponId,
        packageId: packageId,
        coupon: coupon
      });
      (0, _api.removeCouponFromPackageApi)(packageId, couponId).then(function (res) {
        console.log('Remove coupon success', res);
        _this2.$message.success('优惠券已从券包中移除');
        _this2.fetchCoupons();
        // 刷新上级列表中的券包信息
        _this2.$emit('refresh');
        _this2.loading = false;
      }).catch(function (error) {
        console.error('Remove coupon error:', error);
        _this2.$message.error(error && error.message ? error.message : '移除失败，请重试');
        _this2.loading = false;
      });
    },
    handleRemove: function handleRemove(coupon) {
      var _this3 = this;
      this.$confirm('确定从券包中移除此优惠券吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        iconClass: 'el-icon-warning'
      }).then(function () {
        _this3.removeCoupon(coupon);
      }).catch(function () {
        // 用户取消操作，不做处理
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageData.limit = val;
      this.fetchCoupons();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageData.page = val;
      this.fetchCoupons();
    },
    getTagType: function getTagType(type) {
      var types = {
        1: 'danger',
        // 满减券
        2: 'warning',
        // 折扣券
        3: 'primary' // 其他类型
      };
      return types[type] || 'info';
    },
    getCouponTypeText: function getCouponTypeText(type) {
      var types = {
        1: '满减券',
        2: '折扣券',
        3: '其他'
      };
      return types[type] || '未知';
    },
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        0: 'info',
        // 未开始
        1: 'success',
        // 进行中
        2: 'warning',
        // 已暂停
        3: 'danger' // 已结束
      };
      return statusMap[status] || 'info';
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      // 如果date已经是字符串格式，直接返回
      if (typeof date === 'string') return date;

      // 否则格式化日期
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    formatCouponInfo: function formatCouponInfo(coupon) {
      if (coupon.couponType === 1) {
        return "\u6EE1".concat(coupon.threshold || '--', "\u5143\u51CF").concat(coupon.discount || '--', "\u5143");
      } else if (coupon.couponType === 2) {
        return "\u6EE1".concat(coupon.threshold || '--', "\u5143\u6253").concat(coupon.discount || '--', "\u6298");
      } else {
        return coupon.couponTypeDesc || '其他优惠';
      }
    },
    handleRemoveSuccess: function handleRemoveSuccess() {
      // Refresh data after successful removal
      this.fetchCoupons();
      // Refresh package list in parent component
      this.$emit('refresh');
    },
    navigateToCouponDetail: function navigateToCouponDetail(coupon) {
      // Navigate to the coupon detail page
      this.$router.push({
        path: "/marketing/coupon/detail/".concat(coupon.id)
      });
    },
    handleIssueCountChange: function handleIssueCountChange(coupon, value) {
      var _this4 = this;
      var couponId = coupon.id;
      var packageId = this.packageId;

      // Show loading indicator
      this.$message({
        type: 'info',
        message: '正在更新发放张数...',
        duration: 1000
      });

      // Call API to update issue count
      (0, _api.updateCouponQuantityApi)(packageId, couponId, value).then(function () {
        _this4.$message.success('发放张数更新成功');

        // Update the local state to match the new quantity
        var index = _this4.coupons.findIndex(function (c) {
          return c.id === couponId;
        });
        if (index !== -1) {
          _this4.coupons[index].issueCount = value;
          _this4.coupons[index].quantity = value; // Update both fields for consistency
        }

        // Optionally refresh the list
        // this.fetchCoupons();
      }).catch(function (error) {
        _this4.$message.error('发放张数更新失败: ' + (error.message || '未知错误'));
        // Revert the value on error (optional)
        _this4.$nextTick(function () {
          // Find the coupon and reset its value
          var index = _this4.coupons.findIndex(function (c) {
            return c.id === couponId;
          });
          if (index !== -1) {
            // You may need to fetch the actual value from the server
            _this4.coupons[index].issueCount = _this4.coupons[index].issueCount || 1;
          }
        });
      });
    }
  }
};